import { Box } from "@mui/material";
import DynamicForm from "../../../data/Axios/DynamicForm";
import { adjustLeaveBalanceFields } from "../../../data/DynamicTable/FormsFields/LeaveApplicationForms";
import { generateAndExecuteMutation } from "../../../data/Axios/DynamicService";
import { HRService } from "../../../config";
import Swal from "sweetalert2";

const base_url = HRService.uri;

const leaveBalanceSteps = [
    {
        stepLabel: "Adjust Leave Balance",
        stepDescription: "Update the employee's leave balance (days)",
        fields: ["balance"],
    },
];

const LeaveBalanceForm = ({
    data,
    isEditing,
    onAction,
    onClose,
    refetchData,
}) => {
    // Build initialValues from the row data passed by the drawer
    const initialValues = {
        balance: data?.balance ?? 0,
    };

    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            const mutationData = {
                id: data?.id,
                balance: Number(values.balance),
            };

            const response = await generateAndExecuteMutation(
                "updateEmployeeLeaveBalance",
                mutationData,
                "employeeLeaveBalance",
                base_url
            );

            if (response && Object.values(response)[0] != null) {
                Swal.fire({
                    icon: "success",
                    title: "Success!",
                    text: "Leave balance updated successfully.",
                });
                if (refetchData) refetchData();
                if (onClose) onClose();
            } else {
                throw new Error("No response from server");
            }
        } catch (error) {
            console.error("Error updating leave balance:", error);
            Swal.fire({
                icon: "error",
                title: "Error!",
                text: "Failed to update leave balance. Please try again.",
            });
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Box>
            <DynamicForm
                fields={adjustLeaveBalanceFields}
                steps={leaveBalanceSteps}
                initialValues={initialValues}
                onSubmit={handleSubmit}
            />
        </Box>
    );
};

export default LeaveBalanceForm;
